import React, { useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import storage from "utils/Storage";

// Tabs
import Account from "./Account";
import Security from "./Security";
import Preferences from "./Preferences";
import ApiKeys from "./Api";
import Verification from "./Verification";
import Offers from "./Offers";

// Icons
import { 
  UserCircle2, 
  ShieldCheck, 
  Settings2, 
  Code2, 
  BadgeCheck, 
  Gift 
} from "lucide-react";

const SettingsContainer = styled.div`
  display: flex;
  color: #fff;
  max-width: 1100px;
  margin: 0 auto;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.div`
  width: 250px !important;
  flex-shrink: 0 !important;
  padding: 16px 0 !important;
  background-color: #122129 !important;
  border: 1px solid #2f4553 !important;
  border-radius: 8px !important;
  position: sticky !important;
  top: 80px !important;
  align-self: flex-start !important;

  @media (max-width: 768px) {
    width: 100% !important;
    display: flex !important;
    overflow-x: auto !important;
    border-right: none !important;
    border-bottom: 1px solid #2f4553 !important;
    border-left: none !important;
    border-top: none !important;
    border-radius: 0px !important;
    padding: 10px !important;
    background-color: transparent !important;
    
    /* Hide scrollbar for mobile */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const SidebarTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  padding: 0 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled(Link)`
  display: flex !important;
  align-items: center !important;
  padding: 12px 20px !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
  border-left: 3px solid transparent !important;
  
  /* Inactive styles */
  color: #8e969f !important;
  background-color: transparent !important;
  font-weight: normal !important;

  /* Active styles override */
  ${props => props.active ? `
    color: #fff !important;
    background-color: #1b2f3a !important;
    font-weight: bold !important;
    border-left: 3px solid #1475e1 !important;
  ` : ''}

  &:hover {
    color: #fff !important;
    background-color: transparent !important;
    text-decoration: none !important;
  }

  svg {
    width: 20px !important;
    height: 20px !important;
    margin-right: 12px !important;
    /* Inactive icon */
    color: #8e969f !important;
    
    /* Active icon override */
    ${props => props.active ? `
      color: #fff !important;
    ` : ''}
  }

  @media (max-width: 768px) {
    padding: 10px 16px !important;
    border-left: none !important;
    border-bottom: 3px solid transparent !important;
    border-radius: 8px !important;
    white-space: nowrap !important;
    
    ${props => props.active ? `
      border-bottom: 3px solid #1475e1 !important;
    ` : ''}
    
    &:hover {
      background-color: transparent !important;
    }
  }
`;

const OuterWrapper = styled.div`
  padding: 40px 20px;
  min-height: 80vh;

  @media (max-width: 768px) {
    padding: 16px 8px !important;
  }
`;

const ContentArea = styled.div`
  flex-grow: 1;
  width: 100%;
  padding: 0;

  @media (max-width: 768px) {
    padding: 10px 0 !important;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0;
`;

const Setting = () => {
  const history = useHistory();
  const { tab } = useParams();
  
  const currentTab = tab || 'account';

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (storage.getKey('logged') !== 'true') {
      history.push('../');
    }
  }, [history]);

  const renderContent = () => {
    switch (currentTab) {
      case 'account': return <Account />;
      case 'security': return <Security />;
      case 'preferences': return <Preferences />;
      case 'api': return <ApiKeys />;
      case 'verification': return <Verification />;
      case 'offers': return <Offers />;
      default: return <Account />;
    }
  };

  return (
    <OuterWrapper>
      <SettingsContainer>
        <Sidebar>
          <SidebarTitle>Settings</SidebarTitle>
          <NavItem to="/settings/account" active={currentTab === 'account' ? 1 : 0}>
            <UserCircle2 /> Account
          </NavItem>
          <NavItem to="/settings/security" active={currentTab === 'security' ? 1 : 0}>
            <ShieldCheck /> Security
          </NavItem>
          {/* <NavItem to="/settings/preferences" active={currentTab === 'preferences' ? 1 : 0}>
            <Settings2 /> Preferences
          </NavItem> */}
          <NavItem to="/settings/api" active={currentTab === 'api' ? 1 : 0}>
            <Code2 /> API
          </NavItem>
          {/* <NavItem to="/settings/verification" active={currentTab === 'verification' ? 1 : 0}>
            <BadgeCheck /> Verification
          </NavItem>
          <NavItem to="/settings/offers" active={currentTab === 'offers' ? 1 : 0}>
            <Gift /> Offers
          </NavItem> */}
        </Sidebar>
        
        <ContentArea>
          <ContentWrapper>
            {renderContent()}
          </ContentWrapper>
        </ContentArea>
      </SettingsContainer>
    </OuterWrapper>
  );
};

export default Setting;
 
